import { render, staticRenderFns } from "./CardRegister.vue?vue&type=template&id=29afd1e4&"
import script from "./CardRegister.vue?vue&type=script&lang=js&"
export * from "./CardRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports